import { Context } from '@nuxt/types'
import { ShopConfig } from '~/module/shopConfig/shopConfigPlugin'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'

export default async function (context: Context) {
  const shopConfig: ShopConfig | undefined = context.app?.$shopConfig
  const response = await context.app.apolloProvider.defaultClient.query({
    query: GQL_LOCAL_ACCOUNT,
  })
  const account = response.data?.account
  const isLoggedIn: boolean = !!shopConfig?.user.id || !!account?.isLogged

  if (!isLoggedIn) {
    context.redirect('/user/auth/login?return=' + context.route.fullPath)
  }
}
